import createBrowserHistory from 'history/createBrowserHistory';

// configure, create, and export the project's history instance
export default createBrowserHistory({});



// WEBPACK FOOTER //
// ./app/helpers/history.js